module.exports = {
  DataTable: {
    PluginName: "Table",
    style: "Style",
    margin: "Margin",
    left: "Left",
    right: "Right",
    top: "Top",
    bottom: "Bottom",
    padding: "Padding",
    border_width: "Border Width",
    border_style: "Border Style",
    border_color: "Border Color",
    border_radius: "Border Radius",
    opacity: "Opacity",
    title: "Title",
    grid: "Grid",
    x_grid: "X Axis Grid",
    y_grid: "Y Axis Grid",
    line_color: "Line Color",
    file: "Choose File",
    Graph: "Graph",
    edit: "Edit",
    options: {
      ascending: "Ascending",
      descending: "Descending",
      disableFilter: "Row filter",
      disableRowChoice: "Row number selector",
      disablePagination: "Pagination",
      initialPageLength: "No. Rows/page",
      initialSortProp: "Order by column",
      initialOrderProp: "Sort by",
      labels: "Labels",
      noDataLabel: "Empty table message",
      noDataLabel_txt: "No data",
      pageSizeLabel: "Label NºRows/pag",
      pageSizeLabel_txt: "Rows/page",
      searchLabel: "Filter label",
      searchLabel_txt: "Filter rows",
      searchPlaceholder: "Filter placeholder",
      searchPlaceholder_txt: "",
      example_name_surname_txt: "Name Surname",
      example_age_txt: "Age",
      example_country_txt: "Country",

      examplename1: "John Doe",
      examplename2: "Mary Smith",
      examplename3: "Marion  Gilbert",
      examplename4: "Bruce Johnson",
      examplename5: "Ronald Armstrong",
      examplename6: "Brianna Reardown",
      exampleage1: "16",
      exampleage2: "23",
      exampleage3: "18",
      exampleage4: "21",
      exampleage5: "31",
      exampleage6: "37",
      examplecountry1: "USA",
      examplecountry2: "Canada",
      examplecountry3: "Australia",
      examplecountry4: "UK",
      examplecountry5: "Ireland",
      examplecountry6: "Malta",
    },
    or: "Or",
    x_axis: "X Axis",
    y_axis: "Y Axis",
    chart_type: "Chart Type",
    order_by: "Order By",
    data_rows: "Rows",
    data_cols: "Columns",
    key: "Key",
    alert_msg: "Fill in all the fields in the table",
    file_msg: "There is a problem with the file you uploaded",
    confirm: "Confirm",
    fill_in: "Or fill in a table",
    show: "Show",
    Row: "Row",
    row_name: "Row name",
    header: {
      options: "Table options",
      origin: "Data origin",
      preview: "Preview",
    },
    inline: {
      add_row: "Add row",
      add_column: "Add column",
      remove_row: "Remove row",
      remove_column: "Remove column",
      import_csv: "Import CSV",
      done: "Done",
      header_placeholder: "Header",
    },
    table_settings: {
      title: "Table",
      show_search: "Search box",
      show_pagination: "Pagination",
      show_row_choice: "Rows-per-page picker",
      transparent_bg: "Transparent background",
      page_length: "Rows per page",
      sort_column: "Sort column",
      sort_none: "No sorting",
      sort_order: "Sort order",
      column_n: "Column {{n}}",
    },
    theme: {
      label: "Theme",
      basic: "Basic",
      striped: "Striped",
      "rows-only": "Border only in rows",
      solid: "Solid header",
      thick: "Thick border",
    },
  },
};
